
const postalCodeValidatorBR = (postcode) => {
    const zipFormat = new RegExp('^[0-9]{5}-[0-9]{3}$');
    return postcode && zipFormat.test(postcode);
};

export default postalCodeValidatorBR;
